import classNames from 'classnames';
import React from 'react';

interface HighlightWrapperProps {
  children: React.ReactNode;
  highlight?: boolean;
  className?: string;
}

const HighlightWrapper: React.FC<HighlightWrapperProps> = ({ children, highlight, className }) => {
  return <div className={classNames('rounded-lg bg-transparent', className, { 'animate-highlight': highlight })}>{children}</div>;
};

export default HighlightWrapper;
